import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../wayfinder'
import accounts from './accounts'
import brands from './brands'
import users from './users'
import sso from './sso'
import csm from './csm'
import contracts from './contracts'
/**
* @see \App\Http\Controllers\CompanyController::index
* @see app/Http/Controllers/CompanyController.php:32
* @route '/companies'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/companies',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CompanyController::index
* @see app/Http/Controllers/CompanyController.php:32
* @route '/companies'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CompanyController::index
* @see app/Http/Controllers/CompanyController.php:32
* @route '/companies'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CompanyController::index
* @see app/Http/Controllers/CompanyController.php:32
* @route '/companies'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\CompanyController::store
* @see app/Http/Controllers/CompanyController.php:58
* @route '/companies'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/companies',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\CompanyController::store
* @see app/Http/Controllers/CompanyController.php:58
* @route '/companies'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CompanyController::store
* @see app/Http/Controllers/CompanyController.php:58
* @route '/companies'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CompanyController::edit
* @see app/Http/Controllers/CompanyController.php:65
* @route '/companies/{company}/edit'
*/
export const edit = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/companies/{company}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CompanyController::edit
* @see app/Http/Controllers/CompanyController.php:65
* @route '/companies/{company}/edit'
*/
edit.url = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return edit.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CompanyController::edit
* @see app/Http/Controllers/CompanyController.php:65
* @route '/companies/{company}/edit'
*/
edit.get = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CompanyController::edit
* @see app/Http/Controllers/CompanyController.php:65
* @route '/companies/{company}/edit'
*/
edit.head = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\CompanyController::update
* @see app/Http/Controllers/CompanyController.php:77
* @route '/companies/{company}'
*/
export const update = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put","patch"],
    url: '/companies/{company}',
} satisfies RouteDefinition<["put","patch"]>

/**
* @see \App\Http\Controllers\CompanyController::update
* @see app/Http/Controllers/CompanyController.php:77
* @route '/companies/{company}'
*/
update.url = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return update.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CompanyController::update
* @see app/Http/Controllers/CompanyController.php:77
* @route '/companies/{company}'
*/
update.put = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\CompanyController::update
* @see app/Http/Controllers/CompanyController.php:77
* @route '/companies/{company}'
*/
update.patch = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Company\SecurityController::__invoke
* @see app/Http/Controllers/Company/SecurityController.php:15
* @route '/companies/{company}/security'
*/
export const security = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: security.url(args, options),
    method: 'get',
})

security.definition = {
    methods: ["get","head"],
    url: '/companies/{company}/security',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Company\SecurityController::__invoke
* @see app/Http/Controllers/Company/SecurityController.php:15
* @route '/companies/{company}/security'
*/
security.url = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return security.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\SecurityController::__invoke
* @see app/Http/Controllers/Company/SecurityController.php:15
* @route '/companies/{company}/security'
*/
security.get = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: security.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Company\SecurityController::__invoke
* @see app/Http/Controllers/Company/SecurityController.php:15
* @route '/companies/{company}/security'
*/
security.head = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: security.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ToggleCompanyActiveStateController::__invoke
* @see app/Http/Controllers/ToggleCompanyActiveStateController.php:21
* @route '/companies/{company}/toggle-active'
*/
export const toggleActive = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: toggleActive.url(args, options),
    method: 'put',
})

toggleActive.definition = {
    methods: ["put"],
    url: '/companies/{company}/toggle-active',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\ToggleCompanyActiveStateController::__invoke
* @see app/Http/Controllers/ToggleCompanyActiveStateController.php:21
* @route '/companies/{company}/toggle-active'
*/
toggleActive.url = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return toggleActive.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ToggleCompanyActiveStateController::__invoke
* @see app/Http/Controllers/ToggleCompanyActiveStateController.php:21
* @route '/companies/{company}/toggle-active'
*/
toggleActive.put = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: toggleActive.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Company\CsmController::csmContracts
* @see app/Http/Controllers/Company/CsmController.php:25
* @route '/companies/{company}/csm-contracts'
*/
export const csmContracts = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: csmContracts.url(args, options),
    method: 'get',
})

csmContracts.definition = {
    methods: ["get","head"],
    url: '/companies/{company}/csm-contracts',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Company\CsmController::csmContracts
* @see app/Http/Controllers/Company/CsmController.php:25
* @route '/companies/{company}/csm-contracts'
*/
csmContracts.url = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return csmContracts.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\CsmController::csmContracts
* @see app/Http/Controllers/Company/CsmController.php:25
* @route '/companies/{company}/csm-contracts'
*/
csmContracts.get = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: csmContracts.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Company\CsmController::csmContracts
* @see app/Http/Controllers/Company/CsmController.php:25
* @route '/companies/{company}/csm-contracts'
*/
csmContracts.head = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: csmContracts.url(args, options),
    method: 'head',
})

const companies = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    accounts: Object.assign(accounts, accounts),
    brands: Object.assign(brands, brands),
    security: Object.assign(security, security),
    toggleActive: Object.assign(toggleActive, toggleActive),
    users: Object.assign(users, users),
    sso: Object.assign(sso, sso),
    csmContracts: Object.assign(csmContracts, csmContracts),
    csm: Object.assign(csm, csm),
    contracts: Object.assign(contracts, contracts),
}

export default companies